import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

// Audit rows behind the History tab. Standalone: the tab queries by ObjectUSID rather than following
// a parent, so history stays continuous across the object's revisions.
class ObjectAuditHistoryEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ObjectAuditHistory";
        this.primaryEnterpriseComponent = "ObjectAuditHistory";

        const eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ObjectAuditHistory";
        eom.enterpriseComponent = "ObjectAuditHistory";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ObjectAuditHistoryEnterpriseObjectMetadata;
